// extracted by mini-css-extract-plugin
module.exports = {"productIntroduction":"ProductIntroduction_productIntroduction__c_NAE","ef-box":"ProductIntroduction_ef-box__klwsO"};